import { toaster } from 'baseui/toast';

export const copyToClipboard = (str: string) => {
  navigator.clipboard.writeText(str).then(
    () => toaster.info('Link copied to clipboard', { autoHideDuration: 5000 }),
    () => toaster.negative('Error copying link to clipboard', { autoHideDuration: 5000 })
  );
};
